import axios from "axios";

const baseURL = import.meta.env.VITE_APP_BACKEND_API_URL;

export const axiosInstance = axios.create({
  baseURL: baseURL
});

export const addUserRequestHeadersInterceptor = (
  getAccessToken: () => Promise<string>
) => {
  return axiosInstance.interceptors.request.use(async config => {
    const token = await getAccessToken();

    if (token) {
      config.headers.set("Authorization", `Bearer ${token}`);
    }
    config.headers.set("Accept-Language", navigator.language);

    return config;
  });
};

export function ejectRequestInterceptor(interceptorId: number) {
  axiosInstance.interceptors.request.eject(interceptorId);
}
